import { Box, Col } from '@opendoor/bricks-next';
import { EntryComponent } from 'cms/entries/entries';
import { Desc, TitleWithAccent } from 'components/landing-pages-v2/shared/Typography';
import { ILpComponentLwcTextSection } from 'declarations/contentful';

import Grid, { gridStyles } from './Grid';

const RenderLWCTextSection = (entry: ILpComponentLwcTextSection) => {
  const { fields } = entry;
  const analyticsName = `cosmos-landing-page-lwc-text-section-${fields?.analyticsId}`;

  return (
    <Col analyticsName={analyticsName} trackImpression>
      <Grid>
        <Box
          $platform-web={{ gridColumn: gridStyles.colSpan12 }}
          width="100%"
          flexDirection="column"
          gap="$10x"
          mt="$32x"
          mb="$24x"
          $largerThanXS={{
            mt: '$50x',
            mb: '$32x',
          }}
          $largerThanSM={{
            gap: '$16x',
            mt: '$40x',
            mb: '$40x',
          }}
          $largerThanLG={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Col width="100%" gap="$4x">
            <TitleWithAccent title={fields?.title} maxWidth="unset" />
            <Desc $largerThanMD={{ fontSize: 24 }}>{fields?.description}</Desc>
          </Col>
        </Box>
      </Grid>
    </Col>
  );
};

const LWCTextSection: EntryComponent<ILpComponentLwcTextSection> = {
  render: RenderLWCTextSection,
};

export default LWCTextSection;
